export default {
  // Generic
  ADD: 'Add',
  ADD_NEW: 'Add new',
  EDIT: 'Edit',
  PERMISSIONS: 'Permissions',
  DELETE: 'Delete',
  REMOVE: 'Remove',
  DUPLICATE: 'Duplicate',
  CONFIGURE: 'Configure',
  EDIT_DETAILS: 'Edit details',
  LABEL: 'Label',
  ALL: 'All',
  DOWNLOAD: 'Download',
  CANCEL: 'Cancel',
  CONTINUE: 'Continue',
  IMPORT: 'Import',
  EXPORT: 'Export',
  PROCEED: 'Proceed',
  ROLE_TEXT: 'Role',
  ROLE_PLACEHOLDER: 'Select role',
  APPLY: 'Apply',
  RESET: 'Reset',
  CLEAR: 'Clear',
  CLOSE: 'Close',
  CONFIRM: 'Confirm',
  YES: 'Yes',
  NO: 'No',
  SAVE: 'Save',
  CREATE: 'Create',
  SAVE_CHANGES: 'Save changes',
  SAVE_AND_CONTINUE: 'Save and proceed',
  UPDATE: 'Update',
  REVOKE: 'Yes, revoke',
  DEFAULT_CONFIRMATION_TITLE: 'Unsaved changes will be lost',
  DEFAULT_CONFIRMATION_MESSAGE: 'Are you sure?',
  INACTIVE: 'Inactive',
  ACTION: 'Action',
  SEARCH: 'Search',
  DETAILS: 'Details',
  ANALYTICS: 'Analytics',
  HEATMAP: 'Heatmap',
  BACK: 'Back',
  DISCARD: 'Discard',
  VIEW_SURVEY: 'View survey',
  LOGOUT: 'Logout',
  RETRY: 'Retry',
  LOGOUT_MESSAGE: 'Are you sure you want to logout?',
  NEXT: 'Next',
  END: 'End of the form',
  SPLITTER: '_',
  EMPTY_LIST_MESSAGE: "You haven't added any _ yet.",
  EMPTY_LIST_DIRECTIVE: 'Click the _ button to add _',
  EMPTY_FILTER_QUERY_MESSAGE: 'No _ found for your query',
  EMPTY_LIST_ERROR_MESSAGE:
    'Sorry we are unable to load all the _.\nPlease click on the retry button',
  OKAY: 'Okay',
  DEFAULT_ERROR_MESSAGE:
    'Sorry we are unable to process your request.\nPlease try and refresh the application',
  COLOUR: 'Colour',
  TAB_BY_EXISTING_LIST: 'By Existing list',
  TAB_BY_URL: 'By URL',
  SIGNAL_R_CONNECTING: 'SignalR is connecting...',
  SIGNAL_R_CONNECTION_SUCCESSFUL: 'SignalR connected successfully',
  SIGNAL_R_CONNECTION_FAILED: 'Unable to connect to SignalR',
  SIGNAL_R_DISCONNECTION_SUCCESSFUL: 'SignalR disconnected',
  SIGNAL_R_DISCONNECTION_FAILED: 'Unable to disconnect from SignalR',
  LAST_24_HOURS: 'Last 24 Hours',
  FILTERS: 'Filters',
  INTERNAL_SERVER_ERROR: 'Internal server error',
  NOT_IMPLEMENTED: 'Not implemented',
  BAD_GATEWAY: 'Bad gateway',
  SERVICE_UNAVAILABLE: 'Service unavailable',
  GATEWAY_TIMEOUT: 'Gateway timeout',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  SUCCESS: 'Success',
  MOVED_PERMANENTLY: 'Moved permanently',
  MOVED_TEMPORARILY: 'Moved temporarily',
  UNAUTHORIZED: 'Unauthorized',
  FORBIDDEN: 'Forbidden',
  NOT_FOUND: 'Not found',
  PROFILE: 'Profile',
  ACTIVITIES: 'Activities',
  SUCCESSFUL: 'Successful',
  STARTED: 'Started',
  RESPONDED: 'Responded',
  SENT: 'Sent',
  TODAY: 'Today',
  SELECT_ALL: 'Select all',
  ACTIVITY_SEARCH_PLACEHOLDER: 'Search by geofence or officer',
  DELETED_SUCCESSFULLY: 'deleted successfully',
  UPDATED_SUCCESSFULY: 'updated successfully',
  VIEW: 'View',
  ADD_GEOFENCES: 'Add geofences',
  ADD_OFFICERS: 'Add officers',
  ADD_SURVEY: 'Add survey',
  ADD_TEAMS: 'Add teams',
  REFRESH: 'Refresh',
  SHOW_AUTHORIZED_LABEL: 'Show authorised only',
  PHOTOS_AND_DOCUMENTS_TITLE: 'Photos and documents',
  NO_PHOTOS_AND_DOCUMENTS: 'No photos or documents uploaded',
  CONFIGURE_TEMPLATE_DATA: 'Configure form data',
  UPLOAD: 'Upload',
  NOTIFICATIONS: 'Notifications',
  NO_NOTIFICATIONS: 'No new notifications',
  OLDER_NOTIFICATIONS: 'Older notifications',
  READ_ONLY_LABEL: '(Read-only)',
  EXPORT_PDF: 'Export PDF',
  DISABLE: 'Disable',
  ARCHIVE: 'Archive',
  START_DATE_LABEL: 'Start date',
  NOT_ASSIGNED: '-',
  CURRENT_ODOMETER_READING: 'Current odometer reading of the asset',
  CURRENT_MACHINE_HOURS_READING: 'Current machine hours of the asset',

  // AppBar titles
  TEMPLATE_ADD_APP_BAR_TITLE: 'Create new form',

  // Login
  HERO_TITLE: 'Advanced Tracking management software',
  HERO_SUBTITLE:
    'Lorem ipsum dolor sit amet consectetur. Non massa feugiat id ac amet tristique feugiat id ac amet tristique ',
  DASHBOARD_TITLE: 'Dashboard',
  TAGLINE: 'SERVING COMMUNITIES TO MAKE THEM SAFER AND STRONGER',
  LOGIN_TITLE: 'Sign in',
  LOGIN_TITLE_DESCRIPTION: 'Log in to your account',
  FORGOT_PASSWORD_TITLE: 'Forgot Password',
  FORGOT_PASSOWRD_TITLE_DESCRIPTION: 'Enter your email to reset your password',
  RESET_PASSWORD_TITLE: 'Reset Password',
  RESET_PASSOWRD_TITLE_DESCRIPTION: 'Enter and update your password',
  SET_PASSWORD_TITLE: 'Set Password',
  SET_PASSWORD_TITLE_DESCRIPTION: 'Set your password',
  EMAIL_INPUT_LABEL: 'Email Address',
  EMAIL_INPUT_PLACEHOLDER: 'Enter email',
  USERNAME_INPUT_LABEL: 'Username',
  PASSWORD_INPUT_LABEL: 'Password',
  PASSWORD_INPUT_PLACEHOLDER: 'Enter password',
  NEW_PASSWORD_INPUT_LABEL: 'New password',
  NEW_PASSWORD_INPUT_PLACEHOLDER: 'Enter new password',
  CONFIRM_PASSWORD_INPUT_LABEL: 'Confirm password',
  CONFIRM_PASSWORD_INPUT_PLACEHOLDER: 'Confirm new password',
  LOGIN_BUTTON_LABEL: 'Login',
  LOGIN_ISSUE_QUESTION: 'Trouble logging into your account?',
  SEND_MAIL_AT: 'mail at',
  THUMBMUNKEYS_BRANDING: 'Developed by',
  THUMBMUNKEYS: 'Thumbmunkeys',
  THUMBMUNKEYS_WEBSITE: 'https://thumbmunkeys.com',
  SUBMIT: 'Submit',
  FORGOT_PASSWORD: 'Forgot password?',
  BACK_TO_LOGIN: 'Back to login',
  REMEMBER_USER: 'Keep me logged in',
  CHANGE_PASSWORD: 'Change password',
  RESET_PASSWORD_REQUEST_SUCCESS: 'Password reset request sent successfully',
  RETRY_MESSAGE: "Haven't received an email yet?",
  RETRY_IN: 'Retry in',
  PASSWORD_RESET_SUCCESS: 'Password reset successfully.',
  PASSWORD_SET_SUCCESS: 'Password set successfully.',
  PASSWORD_SET_SUCCESS_MESSAGE: 'Please login with your new password.',
  PASSWORD_REQUIREMENT_TITLE: 'Password should contain',

  // Errors
  COMPONENT_ERROR: 'Client Error',
  NETWORK_ERROR: 'Server Error',
  NETWORK_UNAVAILABLE: 'No internet connection',
  NETWORK_ERROR_UNKNOWN: 'Service currently unavailable. Please try again later.',
  CORRUPT_IMPORT_ERROR: 'Error: Invalid or corrupt file',
  FILE_PARSING_FAILED_MESSAGE: 'Failed to parse file:',
  ERROR_LABEL: 'Error',
  ERROR_CLASSES: 'Occured at element with classes:',
  ERROR_PROPS: 'Props: ',
  ERROR_COMPONENT: 'Component: ',
  ERROR_IGNORES: ['canceled'],
  DOWNLOAD_AND_FIX_MESSAGE: 'Please download the file to fix the issues and re-upload the file.',
  DOWNLOAD_FILE_MESSAGE: 'Please download the file to view errors.',

  // List
  NO_DATA_TITLE: 'No Data Yet',
  NO_DATA_MESSAGE: 'Click on the button to add one',

  // Jobs
  CREATE_JOB: 'Create job',
  JOBS: 'Jobs',
  ADD_JOB: 'Add job',
  EDIT_JOB: 'Edit job',
  START_JOB: 'Start job',
  COMPLETE_JOB: 'Complete job',
  VIEW_ORIGINAL: 'View original',
  EMPLOYEE_SAFETY_CHECK_INFORMATION: 'Is the employee safety checklist completed?',
  JOB_SCHEDULE: 'Schedule',
  JOB_STATUS_CHANGED: 'The status of the job has been changed. Click here to refresh.',
  JOB_UPDATED: 'The job has been updated. Click here to refresh.',

  // Job Schedules
  ADD_JOB_SCHEDULE: 'Add schedule',

  // Template
  TEMPLATES: 'Forms',
  ADD_TEMPLATE: 'Add form',
  CREATE_TEMPLATE: 'Add section',
  EDIT_TEMPLATE: 'Edit form',
  TEMPLATE_NAME_LABEL: 'Section name',
  ALL_CATEGORIES: 'All Categories',
  ADD_TEMPLATES: 'Add form',
  HEADER_INFORMATION: 'Header section',
  BODY_INFORMATION: 'Body section',
  FOOTER_INFORMATION: 'Footer section',
  TEMPLATE_INFORMATION_LABEL: 'Label',
  TEMPLATE_INFORMATION_TEXT: 'Text',
  TEMPLATE_INFORMATION_DATE: 'Date and time',
  ADD_FIELDS: 'Add Fields',
  ADD_FIELD: 'Add Field',
  ADD_ITEMS: 'Add Items',
  ADD_ITEM: 'Add Item',
  TEMPLATES_LIST_TITLE: 'Title',
  TEMPLATES_LIST_TYPE: 'Type',
  TEMPLATES_LIST_CREATED_ON: 'Created on',
  TEMPLATE_TITLE_REQUIRED_RULE: 'Title is required',
  TEMPLATE_DELETE_WARNING: 'Do you want to delete forms',
  MANDATORY_INPUT: 'Mandatory',
  USE_AS_HEADER: 'Use as header',

  // Machines
  GENERAL_DETAILS: 'General details',
  SPECIFICATIONS: 'Specifications',
  READINGS: 'Readings',
  DIMENSIONS: 'Dimensions',
  WORK_HOURS: 'Machine hours',
  WHEELS_AND_TYRES: 'Wheels and tyres',
  NAME: 'Name',
  MODEL: 'Model',
  SERIAL_NUMBER: 'Serial number',
  TYPE: 'Type',
  STATUS: 'Status',
  WIDTH: 'Width',
  HEIGHT: 'Height',
  LENGTH: 'Length',
  WEIGHT: 'Weight',
  VOLUME: 'Volume',
  SUMMARY: 'Summary',
  BRAND: 'Brand',
  FRONT_TRACK_WIDTH: 'Front track width',
  REAR_TRACK_WIDTH: 'Rear track width',
  WHEELBASE: 'Wheelbase',
  FRONT_WHEEL_DIAMETER: 'Front wheel diameter',
  REAR_WHEEL_DIAMETER: 'Rear wheel diameter',
  REAR_AXEL: 'Rear axel',
  FRONT_TYRE_TYPE: 'Front tyre type',
  FRONT_TYRE_PSI: 'Front tyre PSI',
  REAR_TYRE_TYPE: 'Rear tyre type',
  REAR_TYRE_PSI: 'Rear tyre PSI',
  MACHINE_HOURS: 'Machine hours',
  MACHINE_HOURS_UPDATE_TITLE: 'Machine hour entry',
  MACHINE_HOURS_CREATE_TITLE: 'Add machine hour entry',

  // Vehicles
  ADD_VEHICLE: 'Add vehicle',
  VEHICLE_ODOMETER_READING_LABEL: 'Odometer reading',
  VEHICLE_FUEL_ECONOMY_TITLE: 'Fuel economy',
  VEHICLE_ENGINE_SPECIFICATIONS_TITLE: 'Engine specifications',
  VEHICLE_INTERNAL_VOLUME_LABEL: 'Internal volume',
  VEHICLE_PASSENGER_VOLUME_LABEL: 'Passenger volume',
  VEHICLE_CARGO_VOLUME_LABEL: 'Cargo volume',
  VEHICLE_GROUND_CLEARANCE_LABEL: 'Ground clearance',
  VEHICLE_FUEL_TYPE_LABEL: 'Fuel type',
  VEHICLE_FUEL_TANK_CAPACITY_LABEL: 'Fuel tank capacity',
  VEHICLE_HIGHWAY_MILEAGE_LABEL: 'Mileage on highway',
  VEHICLE_CITY_MILEAGE_LABEL: 'Mileage in city',
  VEHICLE_OVERALL_MILEAGE_LABEL: 'Overall mileage',
  VEHICLE_BRAND_LABEL: 'Brand',
  VEHICLE_ASPIRATION_TYPE_LABEL: 'Aspiration type',
  VEHICLE_BLOCK_TYPE_LABEL: 'Block type',
  VEHICLE_BORE_LABEL: 'Bore',
  VEHICLE_CAM_TYPE_LABEL: 'Cam type',
  VEHICLE_COMPRESSION_LABEL: 'Compression',
  VEHICLE_CYLINDER_LABEL: 'Cylinders',
  VEHICLE_DISPLACEMENT_LABEL: 'Displacement',
  VEHICLE_FUEL_INDUCTION_LABEL: 'Fuel induction',
  VEHICLE_MAX_HP_LABEL: 'Max HP',
  VEHICLE_MAX_TORQUE_LABEL: 'Max torque',
  VEHICLE_REDLINE_RPM_LABEL: 'Redline RPM',
  VEHICLE_STROKE_LABEL: 'Stroke',
  VEHICLE_VALVES_LABEL: 'Valves',
  VEHICLE_DRIVE_TYPE_LABEL: 'Drive type',
  VEHICLE_BRAKE_SYSTEM_LABEL: 'Brake system',
  VEHICLE_EDIT_DETAILS: 'Edit vehicle',
  VEHICLE_FUEL_HISTORY: 'Fuel history',
  VEHICLE_FUEL_HISTORY_CREATE_TITLE: 'Create new fuel entry',
  VEHICLE_FUEL_HISTORY_UPDATE_TITLE: 'Fuel entry',
  VEHICLE_METER_HISTORY: 'Meter history',
  VEHICLE_METER_HISTORY_CREATE_TITLE: 'Create new meter entry',
  VEHICLE_METER_HISTORY_UPDATE_TITLE: 'Meter entry',

  // Work orders
  WORK_ORDERS: 'Orders',
  ADD_WORK_ORDER: 'Create purchase order',

  // Mill orders
  MILL_ORDERS: 'Mill orders',
  MILL_ORDER_FORM: 'Mill order form',
  MANAGE_MILL_ORDER_FORM: 'Manage mill order form',
  ADD_MILL_ORDER: 'Create mill order',
  ORDER_NUMBER: 'Order number',

  // Equipments
  EQUIPMENTS: 'Equipments',
  ADD_EQUIPMENT: 'Add equipment',
  EQUIPMENT_GENERAL_DETAILS: 'General details',
  EQUIPMENT_SPECIFICATIONS: 'Specifications',
  EQUIPMENT_EDIT_DETAILS: 'Edit equipment',

  // Service programmes
  SERVICE_PROGRAMME: 'Service programme',
  SERVICE_TASKS: 'Service tasks',
  SERVICE_PROGRAMME_CREATE_TITLE: 'Create new service programme',
  SERVICE_PROGRAMME_UPDATE_TITLE: 'Update service programme',
  ADD_SERVICE_PROGRAMME: 'Add Service Programme',

  // Inspections
  INSPECTIONS: 'Inspections',
  ADD_INSPECTION: 'Add Inspection',
  INSPECTION_CREATE_TITLE: 'Create new inspection',
  INSPECTION_UPDATE_TITLE: 'Update inspection',

  // Issues
  ISSUES: 'Issues',
  ISSUE_CREATE_TITLE: 'Create new issue',
  ISSUE_UPDATE_TITLE: 'Update issue',
  ADD_ISSUE: 'Add Issue',

  // Maintenance
  MAINTENANCE: 'Maintenance',
  MAINTENANCE_CREATE_TITLE: 'Create new maintenance',
  MAINTENANCE_UPDATE_TITLE: 'Update maintenance',
  MAINTENANCE_EXTRA_PARTS: 'Extra parts',

  // Services
  ADD_SERVICE: 'Add Service',

  // Service tasks
  ADD_SERVICE_TASK: 'Add Service Task',

  // Vendors
  VENDORS: 'Vendors',
  ADD_VENDOR: 'Add new vendor',

  // Employees
  EMPLOYEES: 'Employees',
  ADD_EMPLOYEE: 'Add new employee',
  EMPLOYEE_FORM_NEXT_OF_KIN_TITLE: 'Next of Kin Details',

  // Machine
  ADD_MACHINE: 'Add machine',
  MACHINE_ODOMETER_READING_LABEL: 'Odometer reading',
  MACHINE_EDIT_DETAILS: 'Edit machine',
  MACHINE_FUEL_HISTORY: 'Fuel history',
  MACHINE_METER_HISTORY: 'Meter history',
  MACHINE_METER_HISTORY_CREATE_TITLE: 'Create new meter entry',
  MACHINE_METER_HISTORY_UPDATE_TITLE: 'Meter entry',
  MACHINE_FUEL_HISTORY_UPDATE_TITLE: 'Fuel entry',
  MACHINE_FUEL_HISTORY_CREATE_TITLE: 'Create new fuel entry',
  MACHINE_INTERNAL_VOLUME_LABEL: 'Internal volume',
  MACHINE_PASSENGER_VOLUME_LABEL: 'Passenger volume',
  MACHINE_CARGO_VOLUME_LABEL: 'Cargo volume',
  MACHINE_GROUND_CLEARANCE_LABEL: 'Ground clearance',
  MACHINE_FUEL_ECONOMY_TITLE: 'Fuel economy',
  MACHINE_FUEL_TYPE_LABEL: 'Fuel type',
  MACHINE_FUEL_TANK_CAPACITY_LABEL: 'Fuel tank capacity',
  MACHINE_HIGHWAY_MILEAGE_LABEL: 'Mileage on highway',
  MACHINE_CITY_MILEAGE_LABEL: 'Mileage in city',
  MACHINE_OVERALL_MILEAGE_LABEL: 'Overall mileage',
  MACHINE_ENGINE_SPECIFICATIONS_TITLE: 'Engine specifications',
  MACHINE_ASPIRATION_TYPE_LABEL: 'Aspiration type',
  MACHINE_BLOCK_TYPE_LABEL: 'Block type',
  MACHINE_BORE_LABEL: 'Bore',
  MACHINE_CAM_TYPE_LABEL: 'Cam type',
  MACHINE_COMPRESSION_LABEL: 'Compression',
  MACHINE_CYLINDER_LABEL: 'Cylinders',
  MACHINE_DISPLACEMENT_LABEL: 'Displacement',
  MACHINE_FUEL_INDUCTION_LABEL: 'Fuel induction',
  MACHINE_MAX_HP_LABEL: 'Max HP',
  MACHINE_MAX_TORQUE_LABEL: 'Max torque',
  MACHINE_REDLINE_RPM_LABEL: 'Redline RPM',
  MACHINE_STROKE_LABEL: 'Stroke',
  MACHINE_VALVES_LABEL: 'Valves',
  MACHINE_DRIVE_TYPE_LABEL: 'Drive type',
  MACHINE_BRAKE_SYSTEM_LABEL: 'Brake system'
}
